// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InsertRowLeftOutlinedSvg from "@ant-design/icons-svg/es/asn/InsertRowLeftOutlined";
import AntdIcon from '../components/AntdIcon';

var InsertRowLeftOutlined = function InsertRowLeftOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InsertRowLeftOutlinedSvg
  }));
};

InsertRowLeftOutlined.displayName = 'InsertRowLeftOutlined';
export default /*#__PURE__*/React.forwardRef(InsertRowLeftOutlined);